import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.Email),
  () => import('./EmailDecoder'),
  (EmailDecoder) => {
    ComponentUtil.binder(Hooks.Email, EmailDecoder);
  },
);
